import * as React from 'react';

const ExclamationPoint24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.025 6.126c-.41 0-.75.34-.75.75v5.5c0 .41.34.75.75.75s.75-.34.75-.75v-5.5c0-.41-.34-.75-.75-.75m1 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11m-1.5 0a9.5 9.5 0 1 0-19 0 9.5 9.5 0 0 0 19 0"
  }
));
ExclamationPoint24.Size = 24;
ExclamationPoint24.Title = "ExclamationPoint";

export { ExclamationPoint24 as default };
